var angular = require('angular');
var _module = require('./index');

_module.directive('numbersDontLie', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/numbers-dont-lie.tmpl.html',
        scope: {
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;

            }
        ]
    };
}]);
